export const marylandCountiesList = [
    'Allegany',
    'Anne Arundel',
    'Baltimore',
    'Baltimore City',
    'Calvert',
    'Caroline',
    'Carroll',
    'Cecil',
    'Charles',
    'Dorchester',
    'Frederick',
    'Garrett',
    'Harford',
    'Howard',
    'Kent',
    'Montgomery',
    'Prince Georges',
    'Queen Annes',
    'St. Marys',
    'Somerset',
    'Talbot',
    'Washington',
    'Wicomico',
    'Worcester',
    ]